// extracted by mini-css-extract-plugin
export default {"component":"CheckoutTips_component__uZgFy","tipInfoText":"CheckoutTips_tipInfoText__1Bt1s","dark":"CheckoutTips_dark__dSHA5"};